export const TAB_GENERAL_SETTINGS = 'GeneralSettings'
export const TAB_CHANGE_PASSWORD = 'ChangePassword'
